/**
 * Átomos de formulário e tabela.
 *
 * Moraram dentro de Cadastros.tsx enquanto só uma tela precisava deles. Saíram
 * daqui quando a segunda apareceu — importar componente de uma tela irmã faria
 * a tela de usuários depender da de cadastros por acidente de layout.
 */
import type { ReactNode } from "react";

export function Campo({
  rotulo, valor, aoMudar, largura = 160, numero, invalido,
}: {
  rotulo: string; valor: string; aoMudar: (v: string) => void;
  largura?: number; numero?: boolean; invalido?: boolean;
}) {
  return (
    <label>
      <span className="rotulo" style={{ display: "block", marginBottom: 4 }}>{rotulo}</span>
      <input
        className={`campo-texto foco-claro${numero ? " num" : ""}`}
        style={{
          width: largura,
          ...(invalido ? { borderColor: "var(--erro-texto)", background: "var(--erro-fundo)" } : {}),
        }}
        value={valor}
        onChange={(e) => aoMudar(e.target.value)}
        {...(numero ? { inputMode: "decimal" as const } : {})}
      />
    </label>
  );
}

export function Selecao({
  rotulo, valor, aoMudar, opcoes, largura = 160,
}: {
  rotulo: string; valor: string; aoMudar: (v: string) => void;
  opcoes: readonly (readonly [string, string])[]; largura?: number;
}) {
  return (
    <label>
      <span className="rotulo" style={{ display: "block", marginBottom: 4 }}>{rotulo}</span>
      <select className="campo-texto foco-claro" style={{ width: largura }}
        value={valor} onChange={(e) => aoMudar(e.target.value)}>
        {opcoes.map(([v, t]) => <option key={v} value={v}>{t}</option>)}
      </select>
    </label>
  );
}

export function Tabela<T>({
  dados, colunas, linha, vazio,
}: {
  dados: T[] | null;
  colunas: string[];
  linha: (d: T) => ReactNode[];
  vazio: string;
}) {
  if (dados === null) {
    return (
      <div className="painel">
        <div className="esq">
          {[0, 1, 2].map((i) => (
            <div className="l" key={i}>
              <span className="b" /><span className="b" /><span className="b" /><span className="b" />
            </div>
          ))}
        </div>
      </div>
    );
  }
  if (dados.length === 0) {
    return <div className="painel"><div className="vazio"><p>{vazio}</p></div></div>;
  }
  return (
    <div className="painel">
      <table className="tab">
        <thead><tr>{colunas.map((c) => <th key={c}>{c}</th>)}</tr></thead>
        <tbody>
          {dados.map((d, i) => (
            <tr key={i}>{linha(d).map((celula, k) => <td key={k}>{celula}</td>)}</tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
